export default __webpack_public_path__ + "static/media/Paper_Upload.e103db98.svg";